"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMlcBillingRuleSchema = exports.createMlcBillingRuleSchema = exports.mlcBillingRuleShape = void 0;
const zod_1 = require("zod");
/** Enterprise Architecture Handbook v1.0 (IP Billing Administration, Module 4 — MLC Rules). */
exports.mlcBillingRuleShape = {
    code: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    waivesDeposit: zod_1.z.boolean().optional(),
    appliesGovernmentRate: zod_1.z.boolean().optional(),
    invoiceRemarksTemplate: zod_1.z.string().max(500).optional(),
};
exports.createMlcBillingRuleSchema = zod_1.z.object(exports.mlcBillingRuleShape);
exports.updateMlcBillingRuleSchema = zod_1.z.object(exports.mlcBillingRuleShape).partial();
//# sourceMappingURL=mlc-billing-rule.schema.js.map